import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
	    { path: '/', component: require(page+'home.vue').default, meta:{title:"Home"}},
	    { path: '/collections', component: require(page+'collections.vue').default, meta:{title:"Collections"}},
	    { path: '/rituals', component: require(page+'rituals.vue').default, meta:{title:"Rituals"}},
	    { path: '/rituals/:id', component: require(page+'ritual.vue').default, meta:{title:"Ritual"}},
	    { path: '/about', component: require(page+'about.vue').default, meta:{title:"About"}},
	    { path: '/faq', component: require(page+'faq.vue').default, meta:{title:"FAQ"}},
	    { path: '/shipping', component: require(page+'shipping.vue').default, meta:{title:"Shipping"}},
	    { path: '/returns', component: require(page+'returns.vue').default, meta:{title:"Returns"}},
	    { path: '/contact', component: require(page+'contact.vue').default, meta:{title:"Contact"}},
	    { path: '/shop', component: require(page+'shop.vue').default, meta:{title:"Shop"}},
	    { path: '/product/:id', component: require(page+'product.vue').default, meta:{title:"Product"}},
	    { path: '/cart', component: require(page+'cart.vue').default, meta:{title:"Cart"}},
	    { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	    { path: '/thanks', component: require(page+'thanks.vue').default, meta:{title:"Thank you"}},
	 ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {	

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}

	
});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter, 
	{ defTitle: "The Conscious Pantry", filter: (title)=>{ return title+" - The Conscious Pantry"; } }
);
	  
// export {routes};
export default MyRouter;